import { create } from "zustand";

interface Bypass404Store {
	gatheringIdentifiers: string[];
	communityIdentifiers: string[];
	addGatheringIdentifier: (identifier: string) => void;
	addCommunityIdentifier: (identifier: string) => void;
}
/**
 * Stores recently deleted and removed identifiers. There's an unavoidable race condition that comes from deleting content.
 * So this store keeps track of recent deletions and removals to prevent 404 pages from showing up.
 */
const useBypass404Store = create<Bypass404Store>((set, get) => ({
	gatheringIdentifiers: [],
	communityIdentifiers: [],
	addGatheringIdentifier: (identifier: string) => {
		set((state) => {
			return {
				...state,
				gatheringIdentifiers: [...state.gatheringIdentifiers, identifier],
			};
		});
	},
	addCommunityIdentifier: (identifier: string) => {
		set((state) => {
			return {
				...state,
				communityIdentifiers: [...state.communityIdentifiers, identifier],
			};
		});
	},
}));
export default useBypass404Store;
